export default __webpack_public_path__ + "static/media/refugee.8ff407cf.png";